export default "__VITE_ASSET__CqkC38Nb__"